var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19 8 3 8a5 5 0 0 1-6 0zV7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5 8 3 8a5 5 0 0 1-6 0zV7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.2b9ace5c96a351b983b03c5c998ebbda.svg";
export { ForwardRef as ReactComponent };